import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
    server: {
        BETTER_AUTH_SECRET: z.string().min(32).max(32),
        BETTER_AUTH_URL: z.string().url(),
        DISCORD_CLIENT_ID: z.string(),
        DISCORD_CLIENT_SECRET: z.string(),
        GOOGLE_CLIENT_ID: z.string(),
        GOOGLE_CLIENT_SECRET: z.string(),
        DATABASE_URL: z.string().url(),
        RESEND_API_KEY: z.string(),
        UPLOADTHING_TOKEN: z.string(),
        DISCORD_WEBHOOK_URL: z.string().optional(),
        OPENAI_API_KEY: z.string(),
        PADDLE_API_KEY: z.string(),
        PADDLE_WEBHOOK_SECRET: z.string(),
    },
    client: {
        NEXT_PUBLIC_APP_URL: z.string().url().default("https://funart.app"),
        NEXT_PUBLIC_PADDLE_CLIENT_TOKEN: z.string(),
        NEXT_PUBLIC_PADDLE_ENV: z
            .enum(["sandbox", "production"])
            .default("sandbox"),
        NEXT_PUBLIC_PADDLE_BASIC_PRICE_ID: z.string(),
        NEXT_PUBLIC_PADDLE_PLUS_PRICE_ID: z.string(),
        NEXT_PUBLIC_PADDLE_PRO_PRICE_ID: z.string(),
    },
    experimental__runtimeEnv: {
        ...process.env,
        NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
        NEXT_PUBLIC_PADDLE_CLIENT_TOKEN:
            process.env.NEXT_PUBLIC_PADDLE_CLIENT_TOKEN,
        NEXT_PUBLIC_PADDLE_ENV: process.env.NEXT_PUBLIC_PADDLE_ENV,
        NEXT_PUBLIC_PADDLE_BASIC_PRICE_ID:
            process.env.NEXT_PUBLIC_PADDLE_BASIC_PRICE_ID,
        NEXT_PUBLIC_PADDLE_PLUS_PRICE_ID:
            process.env.NEXT_PUBLIC_PADDLE_PLUS_PRICE_ID,
        NEXT_PUBLIC_PADDLE_PRO_PRICE_ID:
            process.env.NEXT_PUBLIC_PADDLE_PRO_PRICE_ID,
    },
});
